// Phase 25 iter-9 — i18next setup. Solo dous idiomas (gl, es); o resto
// queda como pendente para iter futura. Detección por (1) localStorage,
// (2) navigator.language. Persiste o cambio manual no localStorage e,
// se hai sesión activa, dispara PATCH /auth/me/language para que o
// backend o lembre nas próximas visitas.

import axios from 'axios';
import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { API_VERSION_PREFIX } from '@leyrochain/shared';

import { es } from './locales/es';
import { gl } from './locales/gl';

export const SUPPORTED_LANGS = ['gl', 'es'] as const;
export type SupportedLang = (typeof SUPPORTED_LANGS)[number];

export const LS_KEY = 'chain:lang';

void i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      gl: { translation: gl },
      es: { translation: es },
    },
    fallbackLng: 'gl',
    supportedLngs: SUPPORTED_LANGS as unknown as string[],
    interpolation: { escapeValue: false }, // React xa escapa
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: LS_KEY,
      caches: ['localStorage'],
    },
  });

/**
 * Cambia o idioma vivo + persiste en localStorage + sincroniza co
 * backend (best-effort) se hai sesión. Non lanza nunca.
 */
export async function setLanguage(lang: SupportedLang): Promise<void> {
  try {
    await i18next.changeLanguage(lang);
    window.localStorage.setItem(LS_KEY, lang);
  } catch {
    /* ignore */
  }
  // Best-effort sync co backend. Usa fetch directo para non tirar do
  // apiClient con interceptores e así evitar erros silenciosos cando
  // o user é anónimo.
  try {
    const token = window.localStorage.getItem('chain:access_token');
    if (!token) return;
    await axios.patch(
      `${API_VERSION_PREFIX}/auth/me/language`,
      { language: lang },
      { headers: { Authorization: `Bearer ${token}` } },
    );
  } catch {
    /* ignore — only the local switch matters */
  }
}

export default i18next;
